// extracted by mini-css-extract-plugin
export default {"price":"D5-z","onSale":"E5-z","msrpLabelPrice":"F5-z","msrpLabel":"G5-z","originalPrice":"H5-z","percentOff":"I5-z"};